import axiosInstance from "../lib/axiosInstance";
import { getFromStorage } from "../lib/storage";

export const fetchCourses = async (params, courseUuid = null) => {
    const url = courseUuid
        ? `/student/course/getAllCourseAndResourcesList?courseUuid=${courseUuid}`
        : `/student/course/getAllCourseAndResourcesList`;
    const response = await axiosInstance.post(url, params);
    return response;
};

export const getBanner = async (params) => {
    const response = await axiosInstance.post("/student/banner/list", params);
    return response.data;
};

export const fetchCourseById = async (uuid) => {
    const token = getFromStorage("lmsCCToken");
    return axiosInstance.get(
        `${token ? "/api" : ""}/student/course/getCourseDetail/${uuid}`
    );
};

export const enrollNow = async (payload) => {
    const token = getFromStorage("lmsCCToken");
    return axiosInstance.post(
        `${token ? "/api" : ""}/student/course/enrollCourse/${payload}`
    );
};